import { EXTERNAL_URLS } from '@dss-libs/shared/type/common-types';

/**
 * Gets country flag (32x24) image url
 * @param countryCode 2 digit Country code
 * @returns Country flag image url
 * @notes This function uses flagcdn.com api
 */
export function getCountryFlagUrl(countryCode: string): string {
  return EXTERNAL_URLS.getCountryFlagUrl(countryCode.toLowerCase());
}
